// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';
import Checkboxes from '../../utils/FormWidgets/Checkboxes';

const StyledRating = styled(StyledMobileBoxItemRow)`
  font-size: 18px;
  margin: 20px 0;
`;

const CheckboxArea = styled(StyledMobileBoxLabel)`
  display: flex;
  align-items: center;

  span {
    color: #000000;
  }
  &&& {
    .checkbox {
      width: auto;
      margin-right: 0;
      margin-bottom: 0;
    }
  }
`;

const ActivitiesRnRMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  content,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getFormattedDateSubmitted,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onFeaturedChange,
}) => (
  <div>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    {content.map(item => (
      <StyledMobileBoxItem key={item.createdAt}>
        <CheckboxArea>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <Checkboxes
              onChange={() => onFeaturedChange(item)}
              options={[{ value: item.userId, label: item.userId }]}
              values={item.featured ? [item.userId] : []}
              noLabel
            />
          }
          <span>Featured</span>
        </CheckboxArea>
        <StyledRating>Rating: {item.rating}</StyledRating>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Review: {item.review}
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Vendor feedback: {item.vendorReview}
        </StyledMobileBoxItemRow>
        <StyledMobileBoxItemRow maxWidth='100%'>
          Date Submitted: {getFormattedDateSubmitted(item)}
        </StyledMobileBoxItemRow>
      </StyledMobileBoxItem>
    ))}
  </div>
);

export default ActivitiesRnRMobile;
